var map = {
	"./cen_b.svg": "4bfe",
	"./kontakt_b.svg": "e12f",
	"./lang_b.svg": "6a40",
	"./lokac_b.svg": "7a99",
	"./menubutton_b.svg": "fac9",
	"./ubyt_b.svg": "b8fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc4b";